module.exports = __webpack_public_path__ + "media/assets/images/webpage-icon-black-0896a66760da0346428828a2802d4457.svg";